<template>
  <div class="">

    <!-- 成功提交面板 -->
    <div class="success-panel outbox">
      <div class="success-icon">
        <img src="@/assets/images/icon-success.png" alt="." />
      </div>
      <div class="success-title" v-if="typeNum == 1 || typeNum == 2">{{ $t('已完成答题') }}</div>
      <div class="success-title" v-if="typeNum == 3">{{ $t('已完成申请') }}</div>
      <div class="success-title" v-if="typeNum == 4 || typeNum == 5 || typeNum == 7 || typeNum == 8">{{ $t('已完成提交') }}</div>
      <div class="success-title" v-if="typeNum == 6">{{ $t('已完成发布') }}</div>


      <div class="success-message" v-if="typeNum != 3">{{ $t('待组委会裁判审核') }}</div>
      <div class="success-message" v-else>{{ $t('已完成xxx的申请，稍后组委会与您联系，交流如何参与大讲堂授课',{num:applyStr}) }}</div>

      <div class="flex-c">
        <button class="submit-btn" @click="continueHandle" v-if="typeNum==3">{{ $t('继续申请') }}</button>
        <button class="submit-btn" @click="continueHandle" v-if="typeNum == 6">{{ $t('继续发布') }}</button>
        <button class="submit-btn" @click="continueHandle" v-if="typeNum == 4 || typeNum == 5 || typeNum == 7 || typeNum == 8">{{ $t('继续提交') }}</button>
        <button class="ml-16 submit-btn" @click="backfn">{{ $t('返回') }}</button>
      </div>

    </div>


    <div class="complete-content outbox">
      
      <!-- 任务积分榜 -->
      <div class="task-ranking">
        <div class="ranking-title">{{$t('任务积分榜')}}</div>
        <div class="ranking-list">
          <div class="rank-item" v-for="(item,index) in taskRanking" :key="index">
            <div class="headbox">
              <img :src="item.user_avatar_att_url || require('@/assets/images/userhead.png')" alt=".">
              <img class="rank-win" v-if="index < 3" :src="require(`@/assets/images/jiangpai${index+1}.png`)" />
              <div class="rank-num" v-else>{{ index + 1 }}</div>
            </div>
            <div class="user-info-item">
              <span class="user-name">{{ item.user_nick_name }}</span>
              <span class="user-points">{{ item.total_score }}{{$t('积分')}}</span>
              <!-- tpsn_score tpsn_stage_one tpsn_stage_two tpsn_stage_three -->
            </div>
          </div>
          <div v-if="taskRanking.length == 0" class="no-data">
            <svg width="100" height="100" t="1744881559460" class="icon" viewBox="0 0 1126 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4474" xmlns:xlink="http://www.w3.org/1999/xlink"><path d="M589.632651 955.143153H22.524851a22.524836 22.524836 0 0 1-22.524836-22.524837v-0.135149a22.705035 22.705035 0 0 1 22.524836-22.727559h102.172657A91.112962 91.112962 0 0 1 112.73682 864.390588V204.525512a90.414692 90.414692 0 0 1 90.099344-90.820139h67.574509V90.842664a90.527317 90.527317 0 0 1 90.099344-90.865189h540.596068a90.459742 90.459742 0 0 1 90.211969 90.662466v659.977699a90.977813 90.977813 0 0 1-12.050787 45.36502h124.652443a22.72756 22.72756 0 0 1 0 45.45512h-270.298034v22.862708a90.820139 90.820139 0 0 1-12.005737 45.36502h12.095837a22.524836 22.524836 0 0 1 22.524836 22.72756 22.750085 22.750085 0 0 1-22.524836 22.772609h-118.503164a45.680368 45.680368 0 0 1-6.915124 55.366048 44.576651 44.576651 0 0 1-63.587613 0h-0.135149z m82.373326-45.500169h71.651504a44.7118 44.7118 0 0 0 31.827593-13.402278 45.590268 45.590268 0 0 0 13.04188-32.233041V203.44432a44.283828 44.283828 0 0 0-12.613908-31.264472 43.427884 43.427884 0 0 0-30.836501-13.064405H201.259426a43.945955 43.945955 0 0 0-43.495459 44.351402v660.518296a45.36502 45.36502 0 0 0 44.869474 45.635318h341.927013l-11.600291-11.757965a45.702893 45.702893 0 0 1-11.69039-43.96848l-21.263445-21.421119a156.637711 156.637711 0 0 1-213.648071-23.290681 160.331784 160.331784 0 0 1 7.703494-216.824073 156.592661 156.592661 0 0 1 214.751788-7.771068 160.309259 160.309259 0 0 1 23.065432 215.697831l21.308495 21.511219a44.486551 44.486551 0 0 1 43.540508 11.757964z m161.412976-113.660324h67.799757a45.229871 45.229871 0 0 0 44.869473-45.455119V90.955288a45.590268 45.590268 0 0 0-13.08693-32.142941 44.7118 44.7118 0 0 0-31.782543-13.357228H360.284769A45.31997 45.31997 0 0 0 315.460345 90.955288v22.77261h427.971887a90.414692 90.414692 0 0 1 90.099345 90.617416z m-348.301542-10.609198a114.516267 114.516267 0 0 0 0-160.872379 111.903386 111.903386 0 0 0-159.318166 0 114.516267 114.516267 0 0 0 0 160.872379 111.925911 111.925911 0 0 0 159.363216 0zM247.773212 250.115781a22.524836 22.524836 0 0 1 22.524837-22.72756h247.773197a22.72756 22.72756 0 0 1 0 45.455119h-247.773197a22.524836 22.524836 0 0 1-22.524837-22.524836z m0 113.727898a22.524836 22.524836 0 0 1 22.367163-22.77261h360.735251a22.750085 22.750085 0 0 1 0 45.500169H270.298049a22.524836 22.524836 0 0 1-22.367163-22.524836z m0 113.772947a22.524836 22.524836 0 0 1 22.524837-22.772609H428.084526a22.367162 22.367162 0 0 1 15.925059 6.75745A22.795134 22.795134 0 0 1 428.084526 500.36671h-157.786477a22.524836 22.524836 0 0 1-22.524837-22.524836z" fill="#E9E9E9" p-id="4475"></path></svg>
            {{$t('暂无数据')}}
          </div>
        </div>
      </div>
      
    </div>
  </div>
  
</template>

<script>
// import { getactQuestion, getactQuestionLike, setactQuestionAdd } from "@api/active";
// import { getMyInfo, setuserfollowAdd } from "@api/home";
import { taskScoreList } from '@/api/challenge';


export default {
  name: 'result',
  props: {
      id: {
          type: [String, Number],
          required: false
      },
      typeNum: {
        type: [String, Number],
        required: false
      },
      continueAction: {
        type: Function,
        required: false
      },
      ta_id: {
        type: [String, Number],
        required: false
      },
      tas_id: {
        type: [String, Number],
        required: false
      },
      tasp_id: {
        type: [String, Number],
        required: false
      },
      applyStr: {
        type: String,
        required: false
      }

  },
  data() {
      return {
        taskRanking: [],
      }
  },
  watch: {
    ta_id: {
      handler(newVal) {
        this.getData();
      },
      immediate: true
    }
  },
  created() {
    
  },

  mounted() {  
    
  },
  methods: {
    async getData() {
      const res = await taskScoreList({ 
        ta_id: this.ta_id,
        tas_id: this.tas_id,
        tasp_id: this.tasp_id,
        page: 1,
        paginate: 12
      });
      if (res.status == 200) {
        this.taskRanking = res.data.data;
      }
    },
    backfn(){
      this.$router.go(-1);
    },
    continueHandle(){
      this.continueAction && this.continueAction();
    }
    
    
  }
}
</script>


<style lang="scss" scoped>
.outbox{
  color: #191919;
  min-width: 1200px;
  max-width: 1680px;
  margin: 0 auto 16px;
  background: #fff;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.05);
  border-radius: 4px;
  box-sizing: border-box;
  padding: 32px;
	&:last-child{
		margin-bottom: 0;
	}
}
.success-panel {
  padding: 56px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  .success-icon {
    width: 72px;
    height: 80px;
    margin-bottom: 16px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  
  .success-title {
    font-size: 20px;
    line-height: 30px;
    margin-bottom: 8px;
  }
  
  .success-message {
    color: #595959;
    line-height: 22px;
    text-align: center;
    padding: 0 32px;
  }
}
.submit-btn {
  box-sizing: border-box;
  border: 1px solid #191919;
  border-radius: 18px;
  padding: 0 22px;
  height: 36px;
  cursor: pointer;
  transition: all 0.3s;
  margin: 24px auto 0;
  background: #fff;
  &:hover {
    border-width: 2px;
  }
}

.task-ranking {
  .ranking-title {
    font-size: 24px;
    line-height: 30px;
    margin-bottom: 24px;
  }
  .ranking-list {
    display: flex;
    flex-wrap: wrap;
    .rank-item {
      display: flex;
      align-items: center;
      margin-bottom: 16px;
      margin-right: 16px;
      width: calc(33.33% - (32px / 3));
      height: 88px;
      padding: 0 12px;
      box-sizing: border-box;
      border: 1px solid rgb(230, 230, 230);
      border-radius: 8px;
      &:nth-child(3n){
        margin-right: 0;
      }
      .headbox{
        margin-right: 12px;
        position: relative;
        flex-shrink: 0;
        img{
          width: 61.79px;
          height: 61.79px;
          border-radius: 50%;
        }
        .rank-win{
          width: 24px;
          height: 24px;
          display: block;
          position: absolute;
          bottom: -4px;
          right: -4px;
          user-select: none;            
        }
        .rank-num{
          font-size: 12px;
          position: absolute;
          bottom: -2px;
          right: -2px;
          width: 20px;
          height: 20px;
          background: #FF826C;
          color: #fff;
          border: 1px solid #fff;
          box-sizing: border-box;
          border-radius: 50%;
          text-align: center;
          line-height: 18px;
          text-wrap: nowrap;
        }
      }
      .user-info-item{
        display: flex;
        justify-content: center;
        flex-direction: column;
        width: calc(100% - 75px);
        .user-name{
          font-size: 20px;
          line-height: 30px;
          margin-bottom: 2px;
          width: 100%;
          text-wrap: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .user-points{
          font-size: 14px;
          color: #FF8000;
          line-height: 22px;
        }
      }
    }
  }
}
.no-data{
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: #999;
  line-height: 22px;
}
</style>